import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

@Pipe({
  name: 'cuiDateOrTimeToday',
  pure: true
})
export class CuiDateOrTimeTodayPipe implements PipeTransform {

  constructor(private datePipe: DatePipe) {

  }

  transform(date?: Date) {
    if (!date) {
      return null;
    }

    const isToday = this.datePipe.transform(date) === this.datePipe.transform(new Date());

    return this.datePipe.transform(date, isToday ? 'HH:mm' : 'dd-MM-y');
  }

}



// WEBPACK FOOTER //
// ./node_modules/@cicero/webui/lib/core/pipes/date-or-time-today.pipe.ts